import { Link } from "react-router-dom";
import { Download, ArrowRight } from "lucide-react";
import { API } from "@/lib/api";

const BrochureCTA = () => {
  return (
    <section className="py-20 lg:py-24 bg-cream" data-testid="brochure-cta-section">
      <div className="container-tm">
        <div className="bg-white rounded-3xl border border-ink/10 shadow-soft overflow-hidden">
          <div className="grid lg:grid-cols-12">
            {/* Left: visual mock of the brochure */}
            <div className="lg:col-span-5 bg-ink p-10 lg:p-14 grain-overlay relative overflow-hidden flex items-center justify-center min-h-[280px]">
              <div className="absolute -top-20 -right-20 w-[260px] h-[260px] bg-gold/25 rounded-full blur-[100px] pointer-events-none" />
              <div className="relative">
                <div className="w-44 h-60 lg:w-52 lg:h-72 bg-sand rounded-lg shadow-lift mx-auto rotate-[-4deg] p-5 flex flex-col justify-between">
                  <div className="space-y-3">
                    <div className="flex items-center gap-1.5">
                      <div className="w-8 h-px bg-ink" />
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-8 h-1 bg-gold rounded" />
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-8 h-px bg-ink/40" />
                    </div>
                  </div>
                  <div className="space-y-1">
                    <div className="font-serif text-ink text-xl leading-tight">Maximisez</div>
                    <div className="font-serif italic text-gold text-xl leading-tight">vos revenus</div>
                    <div className="font-serif text-ink text-xl leading-tight">locatifs.</div>
                  </div>
                  <div className="flex items-end justify-between">
                    <div className="font-sans text-[7px] uppercase tracking-[0.2em] text-ink/60 font-bold">
                      Plaquette<br />2025
                    </div>
                    <div className="text-[7px] font-sans uppercase tracking-[0.2em] text-gold font-bold">
                      10 pages
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: pitch + download */}
            <div className="lg:col-span-7 p-10 lg:p-14 flex flex-col justify-center">
              <span className="overline">Pour aller plus loin</span>
              <h2 className="mt-4 font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
                Téléchargez notre plaquette
                <span className="italic text-gold"> propriétaires</span>.
              </h2>
              <p className="mt-5 font-sans text-base md:text-lg text-ink/70 leading-relaxed max-w-xl">
                10 pages pour comprendre notre offre en un coup d'œil : services, process, tarifs, études de cas et témoignages. Format PDF, prêt à imprimer ou à transférer.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={`${API}/brochure`}
                  download="terre-et-mer-conciergerie-plaquette.pdf"
                  className="btn-accent group"
                  data-testid="brochure-download-btn"
                >
                  <Download size={14} strokeWidth={2} className="mr-3" />
                  Télécharger la plaquette (PDF)
                </a>
                <Link to="/contact" className="btn-secondary group" data-testid="brochure-cta-contact">
                  Parler à un conseiller
                  <ArrowRight size={14} strokeWidth={2} className="ml-3 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>

              <p className="mt-5 text-xs font-sans text-ink/50">
                Édition 2025 · Téléchargement gratuit, sans inscription requise.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrochureCTA;
